import { Link } from "react-router-dom";

export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
  >
    <circle cx="24" cy="24" r="22" stroke="#8C5A3C" strokeWidth="1.4" />
    <path d="M24 13c-3.2 5.4-3.2 12.4 0 18.4 3.2-6 3.2-13 0-18.4z" fill="#C5A059" />
    <path d="M13.5 19.5c3.6 1.6 6.6 5.2 8.4 11-5-1.2-8.4-5.4-8.4-11z" fill="#8C5A3C" opacity="0.9" />
    <path d="M34.5 19.5c-3.6 1.6-6.6 5.2-8.4 11 5-1.2 8.4-5.4 8.4-11z" fill="#8C5A3C" opacity="0.9" />
    <path d="M16 35.5h16" stroke="#C5A059" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
    <LogoMark size={42} className="transition-transform duration-500 group-hover:rotate-[15deg]" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-serif text-2xl tracking-[0.18em] ${
          dark ? "text-cream" : "text-ink"
        }`}
      >
        ODY
      </span>
      <span
        className={`text-[0.6rem] uppercase tracking-[0.35em] mt-1 ${
          dark ? "text-gold" : "text-bronze"
        }`}
      >
        Luxurious Spa
      </span>
    </span>
  </Link>
);
